export const commonConstants = {
  ZIP_LOAD_REQUEST: 'COMMON_ZIP_LOAD_REQUEST',
  ZIP_LOAD_SUCCESS: 'COMMON_ZIP_LOAD_SUCCESS',
  ZIP_LOAD_FAILURE: 'COMMON_ZIP_LOAD_FAILURE',
  ZIP_LOAD_RESET: 'COMMON_ZIP_LOAD_RESET',
}
